import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'
import { setFullHeight } from "../helpers"

import Facet from './Facet'
import RangeFacet from './RangeFacet'

export default ({ showFilters, setShowFilters, clickedFacet, setClickedFacet }) => {
    const { loading, response: { products: { facets } } = {} } = useAppState()

    const { updateSearch, toggleProductFilter } = useActions()

    const [modifiedFilters, setModifiedFilters] = useState([]);
    const [filterFacet, setFilterFacet] = useState()
    const [applyFiltersButtonText, setApplyFiltersButtonText] = useState("Apply All Filters");

    let orderedFacets = facets;

    const customOrder = ["Size", "Color", "Collaborations", "Price", "Category", "Age", "Availability"];

    orderedFacets = facets?.slice().sort((a, b) => {
        return customOrder.indexOf(a.name) - customOrder.indexOf(b.name);
    });

    const handleAddFacetFilters = (e) => {
        e.preventDefault();
        if (modifiedFilters.filter(filter => filter.facet === filterFacet.field).length > 0) {
            modifiedFilters.filter(filter => filter.facet === filterFacet.field).forEach((filter) => {
                toggleProductFilter(filter.facet, filter.value, filter.selected);
            });
        }
        setShowFilters(false);
    }

    useEffect(() => {
        if (window.innerWidth < 769) {
            setFullHeight()

            if (showFilters) {
                document.querySelector("body").style.overflow = "hidden"
            } else {
                document.querySelector("body").style.overflow = "visible"
            }
        }
    }, [window.innerWidth, showFilters])

    useEffect(() => {
        if (modifiedFilters.length > 0) {
            setApplyFiltersButtonText("Apply All Filters");
        } else {
            setApplyFiltersButtonText("Complete Selection");
        }
    }, [modifiedFilters]);

    return facets?.length > 0 ? (
        <>
            <div 
                class={`ns-sidebar-backdrop ${showFilters ? 'ns-sidebar-backdrop--shown' : 'ns-sidebar-backdrop--hidden'}`}
                onClick={() => setShowFilters(false)}
            />

            <div class={`ns-sidebar-wrapper ns-col-3 ns-col-l-2 ${showFilters ? 'ns-sidebar-wrapper--open' : 'ns-sidebar-wrapper--closed'}`}>
                <div class="ns-filter-header ns-p-4">
                    <h3 class="ns-filter-result">Filter Results</h3>
                    <i class="ns-icon ns-icon-close" onClick={() => setShowFilters(false)}></i>
                </div>

                <div class="ns-sidebar-content ns-relative ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {orderedFacets?.map((facet, index) => {
                                switch (facet.type) {
                                    case 'terms':
                                        return <Facet
                                            facet={facet}
                                            index={index}
                                            setShowFilters={setShowFilters}
                                            modifiedFilters={modifiedFilters}
                                            setModifiedFilters={setModifiedFilters}
                                            filterFacet={filterFacet}
                                            setFilterFacet={setFilterFacet}
                                            clickedFacet={clickedFacet}
                                            setClickedFacet={setClickedFacet}
                                        />
                                    case 'stats':
                                        return <RangeFacet
                                            facet={facet}
                                            setShowFilters={setShowFilters}
                                            clickedFacet={clickedFacet}
                                            setClickedFacet={setClickedFacet}
                                        />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
                <button class="button button--primary main-banner__button ns-filter-button" disabled={!modifiedFilters.length > 0} onClick={handleAddFacetFilters}>
                    {applyFiltersButtonText}
                </button>
            </div>
        </>
    ) : (
        ''
    )
}
